module.exports = __webpack_public_path__ + "assets/images/loginf5064d8199b6763146787f3bad7c00ee.svg";